import { Component, ElementRef, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { MenuRouteService } from '../../services/menu-route.service';
import { PricingBannerComponent } from '../../framework/pricing/pricing-banner/pricing-banner.component';
import { InteractionBarComponent } from '../../framework/interaction-bar/interaction-bar.component';
import { MenuBarComponent } from '../../framework/menu-bar/menu-bar.component';
import { projectActions } from '../../store/projects/projects.actions';

@Component({
  selector: 'app-webapp',
  templateUrl: './webapp.component.html',
  styleUrls: ['./webapp.component.scss'],
  providers: [],
  imports: [MenuBarComponent, InteractionBarComponent, PricingBannerComponent, RouterOutlet],
})
export class WebappComponent implements OnInit {
  constructor(
    public el: ElementRef,
    private router: Router,
    private menuState: MenuRouteService,
    private store: Store,
  ) {
    this.router.events.subscribe((ev) => {
      const navEnd = ev as NavigationEnd;
      if (navEnd.url) {
        const page = navEnd.url.split('/')[2];
        this.menuState.setActive(page);
      }
    });
  }

  ngOnInit() {
    this.store.dispatch(projectActions.loadBackendStatuses());
  }
}
